var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H14",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.979 3H7.021C6.469 3 6.021 3.448 6.021 4V6.378C6.021 6.799 6.154 7.21 6.401 7.551L9.621 12L6.401 16.449C6.154 16.79 6.021 17.201 6.021 17.622V20C6.021 20.552 6.469 21 7.021 21H16.978C17.53 21 17.978 20.552 17.978 20V17.658C17.978 17.214 17.83 16.783 17.558 16.432L14.121 12L17.559 7.567C17.831 7.216 17.979 6.785 17.979 6.341V4C17.979 3.448 17.531 3 16.979 3Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.6f1df40a1e86a3dd4154b99cff4e1f24.svg";
export { ForwardRef as ReactComponent };